import { createStrings } from '@utils/local';
import { z } from 'zod';

export const validationStrings = createStrings({
  ja: {
    email: 'メール',
    url: 'URL',
    emoji: '絵文字',
    uuid: 'UUID',
    regex: '正規式',
    cuid: 'CUID',
    cuid2: 'CUID2',
    ulid: 'ULID',
    datetime: '日付',
    ip: 'IP',
  },
});

export const jaErrorMap: z.ZodErrorMap = (error, ctx) => {
  switch (error.code) {
    case 'invalid_type':
      switch (error.received) {
        case 'undefined':
        case 'null':
          return { message: `入力してください。` };
      }

      switch (error.expected) {
        case 'number':
          return { message: '半角数字で入力してください。' };
      }
      break;
    case 'too_small':
      switch (error.type) {
        case 'string':
          if (error.exact) {
            return { message: `${error.minimum}文字で入力してください。` };
          } else if (error.minimum === 1) {
            return { message: `入力してください。` };
          } else {
            return { message: `${error.minimum}文字以上で入力してください。` };
          }
        case 'number':
          if (error.inclusive) {
            return { message: `${error.minimum}以上の数値を入力してください` };
          } else {
            return { message: `${error.minimum}より大きな数値を入力してください` };
          }
        case 'array':
          if (error.exact) {
            return { message: `${error.minimum}項目で入力してください。` };
          } else if (error.minimum === 1) {
            return { message: `入力してください。` };
          } else {
            return { message: `${error.minimum}項目以上で入力してください。` };
          }
      }
      break;
    case 'too_big':
      switch (error.type) {
        case 'string':
          if (error.exact) {
            return { message: `${error.maximum}文字で入力してください。` };
          } else {
            return { message: `${error.maximum}文字以下で入力してください。` };
          }
        case 'number':
          if (error.inclusive) {
            return { message: `${error.maximum}以下の数値を入力してください` };
          } else {
            return { message: `${error.maximum}より小さな数値を入力してください` };
          }
        case 'array':
          if (error.exact) {
            return { message: `${error.maximum}項目で入力してください。` };
          } else {
            return { message: `${error.maximum}項目以下で入力してください。` };
          }
      }
      break;
    case 'invalid_string':
      if (typeof error.validation === 'string') {
        return {
          message: `無効な${
            error.validation in validationStrings
              ? validationStrings[error.validation]
              : error.validation
          }です`,
        };
      }
  }

  return { message: ctx.defaultError };
};
